import {lazy} from 'react'

const TreePlantFotoTreeScreen = lazy(
  () =>
    import(/* webpackChunkName: 'HostProfile' */ './TreePlantFotoTreeScreen'),
)

export {TreePlantFotoTreeScreen}
